// extracted by mini-css-extract-plugin
export default {"dashboardContainer":"dashboard_dashboardContainer__HJRUs","MuiGrid-item":"dashboard_MuiGrid-item__m33Wb","MuiPaper-root":"dashboard_MuiPaper-root__odBBG"};